<template>
    <b-modal id="modalItems" data-backdrop="static" data-keyboard="false" v-model="exibirItens" centered
        :title="this.$t('Informe o serviço')">
        <div class="alert alert-danger" role="alert" v-if="verificaAlertaTempo">
            {{ $t('O tempo total é inferior a 5 minutos. Isso poderá impactar negativamente no controle de gestão') }}.
        </div>
        <v-select class="mb-3" :options="items" v-model="selectServico" :placeholder="$t('Serviços')"></v-select>
        <div>
            <span for="obsItem">{{ $t('Observação') }}:</span>
            <input v-model="obsExterna" type="text" class="form-control" id="obsItem">
        </div>
        <div class="mt-3">
            <span for="obsItem">{{ $t('Informar KM') }}:</span>
            <input v-model="km_atual" type="text" class="form-control">
        </div>

        <div class="container mt-3 anexoArquivos">
            <h6>{{ $t('Anexo de arquivos') }}:</h6>
            <UploadArquivos></UploadArquivos>
        </div>
        <div class="container mt-3 anexoArquivos" v-if="this.os.st_origem == 'E'">
            <h6>{{ $t('Informe o valor total dos serviços/peças') }}:</h6>
            <input v-model="precoTotal" type="number" class="form-control">
        </div>
        <div class="container mt-3 anexoArquivos" v-if="socorroEmRota()">
            <h6>{{ $t('Informe o motivo do socorro em rota') }}:</h6>
            <v-select class="mb-3" :options="motivos" v-model="selectMotivo" :placeholder="$t('Motivo')"></v-select>
        </div>
        <div class="container mt-3 anexoArquivos" v-if="habilitaPneus()">
            <!-- <div class="container mt-3 anexoArquivos" > -->
            <h6>{{ $t('Informe o pneu utilizado neste serviço') }}:</h6>
            <v-select :options="pneusPlaca" v-model="pneuAtendimento"></v-select>
            <hr>
            <div class="">
                <input type="checkbox" name="pneu-novo" id="pneu-novo" @click="habilitaPneuNovo()">
                <label for="pneu-novo" class="ml-1">{{ $t('Foi trocado o pneu') }}?</label>
            </div>

            <h6 :disabled="inputPneuNovo">{{ $t('Informe o pneu novo') }}:</h6>
            <v-select :disabled="inputPneuNovo" v-model="pneuNovo" :options="pneusEstoque"></v-select>
        </div>

        <template #modal-footer>
            <div class="w-100">
                <div class="row center" style="justify-content: center;">
                    <b-button class="mr-2" variant="danger" size="lg" @click="$emit('showModalItems')">
                        {{ $t('Cancelar') }}
                    </b-button>
                    <b-button size="lg" variant="success" @click="submitValues">
                        {{ $t('Finalizar OS') }}
                    </b-button>
                </div>
            </div>
        </template>
    </b-modal>
</template>
<script>
import UploadArquivos from './UploadArquivos.vue';

export default {
    name: "ModalItems",
    props: {
        os: {}
    }, 
    data() {
        return {
            selectServico: "",
            obsExterna: "",
            km_atual: "",
            exibirItens: true,
            idConjunto: "",
            nrSeqOs: "",
            precoTotal: "",
            inputPneuNovo: true,
            pneuAtendimento: '',
            pneuNovo: '',
            motivos: [
                'Erro humano',
                'Quebra do equipamento',
                'Desgaste prematuro da peça',
                'Desgaste natural da peça',
                'Localização da peça',
                'Condição da via',
                'Agente externo',
                'Carrier (quando há bloqueio do equipamento)',
                'Excesso de peso (carregamento errado, manuseio errado)',
            ],
            selectMotivo: "",
            exibirAlertaTempo: false
        };
    }, 
    mounted() {
        // if (this.os && this.os.dt_inicial) {
        //     const dtInicial = new Date(this.os.dt_inicial.split('.')[0].replace(' ', 'T'));
        //     const dtAgora = new Date();
        //     const diffMin = Math.floor((dtAgora - dtInicial) / 1000 / 60);
            
        //     if (diffMin < 5) {
        //         this.exibirAlertaTempo = true;
        //     }
        // }
    },
    computed: {
        verificaAlertaTempo() {
            if (this.os && this.os.dt_inicial) {
                const dtInicial = new Date(this.os.dt_inicial.split('.')[0].replace(' ', 'T'));
                const dtAgora = new Date();
                const diffMin = Math.floor((dtAgora - dtInicial) / 1000 / 60);
                
                if (diffMin < 5) {
                    return true;
                }

                return false
            }

            return false
        },
        pneusPlaca() {
            const pneus = this.$store.getters['veiculo/pneus']

            if (!pneus) {
                const objPlaca = {
                    nr_placa: this.os.nr_placa,
                    nr_seq_filial: this.os.nr_seq_filial
                }
                this.$store.dispatch('veiculo/getPneusVeiculo', { data: objPlaca })

                return []
            }

            return pneus.map(pneu => {
                return {
                    ...pneu,
                    label: pneu.pneu.nr_fogo
                }
            })
        },
        pneusEstoque() {
            const pneusEstoque = this.$store.getters['veiculo/pneusEstoque']

            if (!pneusEstoque) {
                const objPlaca = {
                    nr_placa: this.os.nr_placa,
                    nr_seq_filial: this.os.nr_seq_filial
                }
                this.$store.dispatch('veiculo/getPneusVeiculo', { data: objPlaca })

                return []
            }
 
            return pneusEstoque.map(pneu => {
                return {
                    ...pneu,
                    label: pneu.nr_fogo
                }
            })
        },

        verificaOsExterna() {
            const filial = JSON.parse(localStorage.filial);
            if (this.os.st_origem == "E") {
                return true;
            }
            return false;
        },
        filial() {
            return this.$store.getters["filial/filial"];
        },
        frotaItems() {
            const items = this.$store.getters["frotaItem/items"];
            if (!items && this.filial) {
                this.$store.dispatch("frotaItem/fetchFromApi", {
                    params: {
                        filial: this.filial.nr_sequencial,
                        estoque: true,
                        nr_seq_os: this.$route.params.id
                    }
                });
                return [];
            }
            return items;
        }, 
        
        items() {
            const items = this.frotaItems; 

            var options = [];
            items.forEach(item => {
                console.log(item)
                console.log(this.os)
                var label = ''
                console.log(items)
                const parametro_preditiva = this.$store.getters['frotaItem/getParametroPreditiva']

                if (item.nr_seq_conjunto == this.idConjunto || (this.os.nr_seq_tipo == 13 && parametro_preditiva == true)  ) {
                    console.log('entrou')
                    label = item.ds_item;
                }
                else {
                    return false;
                }


                // Item de serviço
                if (item.tipo) {
                    label = `${label}`;
                    if (item.tipo.st_habilita_execucao || (this.os.nr_seq_tipo == 13 && items.preditiva_item == true)) {
                        delete (item.estoque);
                        options.push({
                            ...item,
                            label: label
                        });
                        return true;
                    }
                }
            });
            // console.log(options)
            return options;
        },
    },

    methods: {
        submitValues() {
            // console.log(this.km_atual)
            // console.log(this.os.km_atual)

            let diferenca = Math.abs(this.os.km_atual - this.km_atual);

            if (this.os.departamento_os == 'ARMAZEM' && diferenca > 744) {
                this.$swal.fire({
                    title: 'Oops!',
                    text: 'Diferença muito grande entre o KM atual e o informado!',
                    icon: 'warning'
                })

                return false
            } 
            
            const valuesOS = {
                nr_servico: this.selectServico.nr_sequencial,
                obsExterna: this.obsExterna,
                km_atual: this.km_atual,
                precoTotal: this.precoTotal,
                pneuAtendimento: this.pneuAtendimento,
                pneuNovo: this.pneuNovo,
                socorroEmRota: ""
            }
            console.log(valuesOS)

            if (this.socorroEmRota()) {
                valuesOS.socorroEmRota = this.selectMotivo

                if (this.selectMotivo == "") {
                    this.$swal.fire({
                        title: 'Oops!',
                        text: 'Insira o motivo para o socorro em rota',
                        icon: 'error'
                    })

                    return false
                }
            }

            this.$emit('saveItem', { ...valuesOS })
        },

        habilitaPneuNovo() {
            this.inputPneuNovo = !this.inputPneuNovo
            this.pneuNovo = ''
        },

        getInfOs() {
            if (this.$route.params.id) {
                this.nrSeqOs = this.$route.params.id;
            }
            else {
                this.nrSeqOs = this.os.nr_sequencial;
            }
            this.$store.dispatch("os/getDetails", {
                nrSequencial: this.nrSeqOs
            }).then(response => {
                this.idConjunto = response.data.nr_conjunto;
                this.km_atual = parseFloat(response.data.km_atual)
                // console.log(response)
            }).catch(error => {
                console.log(error);
            });
        },
 
        getInfPneu() {
            const objPlaca = {
                nr_placa: this.os.nr_placa,
                nr_seq_filial: this.os.nr_seq_filial
            }
            this.$store.dispatch('veiculo/getPneusVeiculo', { data: objPlaca })
        },

        habilitaPneus() {
            try {
                if (this.os.segmento.habilita_pneus == 'S' && this.os.st_origem != 'E') {
                    return true
                }

                return false
            } catch (error) {
                return false
            }
        },
        socorroEmRota() {
            try {
                if (this.os.nr_seq_socorro_emrota != null) {
                    return true
                } else {
                    return false
                }
            } catch (error) {
                return false
            }
        }
    },
    created() {
        this.getInfOs();
        
        try {
            if (this.os.segmento.habilita_pneus == 'S') {
                this.getInfPneu();
            }
        } catch (error) {
            return false
        }

    },
    components: { UploadArquivos }
}
</script>
<style>
    #modalItems {
        pointer-events: none !important;
    }

    .close {
        display: none !important;
    }

    .anexoArquivos {
        padding: 12px;
        border: 1px solid #e3e3e3;
        border-radius: 14px;
        box-shadow: 0px 0px 6px -4px #000;
    }
</style>